import http from '../httpService';
import {getLanguage, t} from 'react-switch-lang';

export function getAllProcesses() {
  return http.get(`/processes`);
}
export async function getAllProcessesAtSubProcesses(page = 0, result = []) {
  const { data } = await http.get(
    `/processes?page=${page}&size=20`
  );

  result.push(...data);

  return data?.length < 20
    ? { data: result }
    : getAllProcessesAtSubProcesses(page + 1, result);
}
export function getAllProcessesActive() {
  return http.get(`/processes?active.equals=true`);
}
export async function getAllProcessesActiveAtSubProcesses(page = 0, result = []) {
  const { data } = await http.get(
    `/processes?page=${page}&size=20&active.equals=true`
  );

  result.push(...data);

  return data?.length < 20
    ? { data: result }
    : getAllProcessesActiveAtSubProcesses(page + 1, result);
}
export function updateProcess(payload) {
  return http.put('/processes', payload);
}

export function createProcess(payload) {
  return http.post('/processes', payload);
}

export function deleteProcess(id) {
  return http.delete(`/processes/${id}`);
}
export function deactivateProcess(id) {
  return http.put(`/processes/${id}/toggle-activation`);
}